<template>
  <mj-modal-wrapper>
    <mj-modal-head>
      <h2 class="font-semibold text-white text-2xl">
        {{ modalHeadline }}
      </h2>
      <small
        v-if="mode === 'create'"
        class="text-indigo-300"
      >
        Erstelle jetzt ein neues Event und gestallte deine Playlist mit all deinen Freunden zusammen.
      </small>
    </mj-modal-head>
    <mj-modal-content>
      <mj-validation-observer
        id="save-event"
        v-slot="{ invalid }"
        ref="formObserver"
        tag="form"
        method="post"
        @submit.prevent="onSubmit"
      >
        <div class="event-save-modal__inputs">
          <mj-input-group>
            <mj-input-label
              for="eventname"
              class="text-lg text-gray-900"
            >
              Eventname
            </mj-input-label>
            <mj-validation-input-field
              v-model="eventForm.name"
              name="eventname"
              rules="required|min:2"
              autofocus
              placeholder="Dein Eventname"
              autocomplete="off"
            />
          </mj-input-group>

          <mj-input-group>
            <mj-input-label
              for="eventdate"
              class="text-lg text-gray-900"
            >
              Datum
            </mj-input-label>
            <mj-date-picker
              popover-direction="top"
              @pick="onPick"
            >
              <mj-validation-input-field
                v-model="eventForm.date"
                name="eventdate"
                :rules="{required: true, regex: /\d{2}(\.|-)\d{2}(\.|-)\d{4}/ }"
                placeholder="YYYY.MM.TT"
                autocomplete="off"
              />
            </mj-date-picker>
          </mj-input-group>
        </div>
        <div class="event-save-modal__buttons flex justify-between mt-12">
          <div class="close">
            <mj-button
              class="btn-naked"
              @click="onClose"
            >
              Abbrechen
            </mj-button>
          </div>
          <div class="submit">
            <mj-button
              class="btn-primary inline-flex"
              :is-busy="isBusy"
              :disabled="invalid"
              @click="onSubmit"
            >
              Speichern
            </mj-button>
          </div>
        </div>
      </mj-validation-observer>
    </mj-modal-content>
  </mj-modal-wrapper>
</template>

<script>
import get from 'lodash.get';
import { mapActions } from 'vuex';
import { format, parse } from 'date-fns';
import DatePicker from '@/components/date-picker/DatePicker.vue';
import ModalWrapper from '@/components/ui/general/modal/ModalWrapper.vue';
import ModalHead from '@/components/ui/general/modal/ModalHead.vue';
import ModalContent from '@/components/ui/general/modal/ModalContent.vue';

export default {

  name: 'EventSaveModal',

  components: {
    'mj-modal-wrapper': ModalWrapper,
    'mj-modal-head': ModalHead,
    'mj-modal-content': ModalContent,
    'mj-date-picker': DatePicker,
  },

  props: {
    params: {
      type: Object,
      required: false,
      default: () => {},
    },
  },

  data() {
    return {
      eventForm: {
        name: '',
        date: '',
      },
      mode: 'create',
      pickedDate: null,
      isBusy: false,
    };
  },

  computed: {
    modalHeadline() {
      if (this.mode === 'update') {
        return `${this.params.event.name} bearbeiten`;
      }
      return 'Es gibt immer einen Grund zum feiern!';
    },
  },

  watch: {
    pickedDate(newDate) {
      this.eventForm.date = format(newDate, 'dd.MM.yyyy');
    },
  },

  methods: {
    ...mapActions(['createEvent', 'updateEvent']),

    onPick({ date }) {
      this.pickedDate = date;
    },

    async onSubmit() {
      if (await this.$refs.formObserver.validate()) {
        const eventData = {
          name: this.eventForm.name,
          starts_on: format(parse(this.eventForm.date, 'dd.MM.yyyy', new Date()), 'yyyy-MM-dd'),
        };
        this.isBusy = true;

        if (this.mode === 'update') {
          this.update(eventData);
        } else {
          this.create(eventData);
        }
      }
    },

    create(eventData) {
      this.createEvent(eventData)
        .then(data => {
          this.$router.push({ name: 'event.track.search', params: { id: data.id } });
          this.onClose();
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => { this.isBusy = false; });
    },

    update(eventData) {
      this.updateEvent({ eventId: this.params.event.id, eventData })
        .then(() => {
          this.onClose();
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => { this.isBusy = false; });
    },

    onClose() {
      this.eventForm = {
        name: '',
        date: '',
      };
      this.isBusy = false;
      this.$modal.hide('root-modal');
    },

  },
  mounted() {
    this.mode = get(this.params, 'mode', 'create');
    if (this.mode === 'update' && this.params.event) {
      this.eventForm.name = get(this.params.event, 'name', '');
      this.eventForm.date = this.params.event.starts_on ? format(parse(this.params.event.starts_on, 'yyyy-MM-dd', new Date()), 'dd.MM.yyyy') : '';
    }
  },
};
</script>
